import React, { Fragment } from 'react';
import { Field, FieldArray } from 'redux-form';
import { RemoveCircle } from '@sparkpost/matchbox-icons';
import styled from 'styled-components';
import { Grid, Box, Button, Panel } from 'src/components/matchbox';
import { OGOnlyWrapper } from 'src/components/hibana';
import { Add } from '@sparkpost/matchbox-icons';
import { TextFieldWrapper } from 'src/components/reduxFormWrappers';
import { TemplateTypeaheadWrapper } from 'src/components/reduxFormWrappers';
import {
  required,
  integer,
  minNumber,
  maxNumber,
  abTestDistribution
} from 'src/helpers/validation';
import styles from './VariantsFields.module.scss';

const RemoveIcon = styled.div`
  margin-left: 2px;
  margin-top: -1px; /* Helps address vertical centering problem */
`;

export const PercentField = ({ namespace, ...props }) => (
  <Field
    name={`${namespace}.percent`}
    label="Percent of total"
    type="number"
    suffix="%"
    validate={[required, minNumber(1), maxNumber(100), abTestDistribution]}
    component={TextFieldWrapper}
    data-track={true}
    {...props}
  />
);

export const SampleSizeField = ({ namespace, ...props }) => (
  <Field
    name={`${namespace}.sample_size`}
    label="Number of Recipients"
    type="number"
    validate={[required, integer, minNumber(1)]}
    component={TextFieldWrapper}
    data-track={true}
    {...props}
  />
);

/*
  If you're looking at this, refer to https://redux-form.com/7.4.2/examples/fieldarrays/
 */
export const RenderVariants = ({ fields, formValues, disabled, subaccountId }) => {
  return (
    <OGOnlyWrapper as={Panel.LEGACY}>
      {fields.map((variant, i) => {
        const CountField =
          formValues.audience_selection === 'sample_size' ? SampleSizeField : PercentField;
        return (
          <Panel.LEGACY.Section key={i}>
            <div className={styles.RemoveWrapper}>
              <Button
                flat
                color="orange"
                size="small"
                onClick={() => fields.remove(i)}
                disabled={fields.length === 1}
              >
                <span>Remove Variant</span>
                <RemoveIcon as={RemoveCircle} />
              </Button>
            </div>
            <h6 className={styles.SmallHeader}>Variant {i + 1}</h6>
            <Grid>
              <Grid.Column>
                <Field
                  name={`${variant}.template_object`}
                  component={TemplateTypeaheadWrapper}
                  label="Select a published template"
                  placeholder="Type to search"
                  validate={required}
                  disabled={disabled}
                  subaccountId={subaccountId}
                  data-track={true}
                />
              </Grid.Column>
              <Grid.Column>
                <CountField namespace={variant} disabled={disabled} />
              </Grid.Column>
            </Grid>
          </Panel.LEGACY.Section>
        );
      })}
      <Panel.LEGACY.Section>
        <Button flat color="orange" onClick={() => fields.push()} disabled={fields.length >= 20}>
          <Add /> Add Another Variant
        </Button>
      </Panel.LEGACY.Section>
    </OGOnlyWrapper>
  );
};

const VariantsFields = ({ disabled, formValues, subaccountId }) => {
  const CountField =
    formValues.audience_selection === 'sample_size' ? SampleSizeField : PercentField;
  return (
    <Fragment>
      <Box as={Panel.LEGACY} mt="400">
        <OGOnlyWrapper as={Panel.LEGACY}>
          <Panel.LEGACY.Section>
            <h6 className={styles.SmallHeader}>Default Template</h6>
            <Grid>
              <Grid.Column>
                <Field
                  name="default_template.template_object"
                  component={TemplateTypeaheadWrapper}
                  label="Select a published template"
                  placeholder="Type to search"
                  validate={required}
                  disabled={disabled}
                  subaccountId={subaccountId}
                  data-track={true}
                />
              </Grid.Column>
              <Grid.Column>
                <CountField namespace="default_template" disabled={disabled} />
              </Grid.Column>
            </Grid>
          </Panel.LEGACY.Section>
        </OGOnlyWrapper>

        <FieldArray
          name="variants"
          component={RenderVariants}
          formValues={formValues}
          disabled={disabled}
          subaccountId={subaccountId}
        />
      </Box>
    </Fragment>
  );
};

VariantsFields.defaultProps = {
  formValues: {}
};

export default VariantsFields;
